<template>
  <div class="container bg-white">
    <div class="row">
      <div class="col-md-12">
        <div class="page-content">
          <div class="center-middle">
            <h4 class="futalis-text-green text-uppercase">
              leider haben wir die seite nicht gefunden
            </h4>
          </div>
          <div class="center-middle">
            <img src="https://media.futalis.com/futalis/interface/404.png"
                 alt="user_is_lost"
            >
          </div>
          <div class="center-middle">
            <a href="javascript:void(0)"
               class="futalis-text-green mt-5"
               @click="$router.push({ name: 'Home' })"
               style="font-size: 22px"
            >zurück zur Startseite
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
};
</script>

<style scoped>
.container {
  min-height: 75vh;
}
.page-content {
  margin-top: 15vh;
}
</style>
